import {Box, Slider, TextField} from '@mui/material';
import React from 'react';

import {useAppSelector} from '../../hooks/redux';

interface SpeedFilterSliderProps {
  min?: number;
  max?: number;
  lowerValue: number;
  upperValue: number;
  onLowerChange: (value: number) => void;
  onUpperChange: (value: number) => void;
}

const SpeedFilterSlider: React.FC<SpeedFilterSliderProps> = ({
  min = 0,
  max = 100,
  lowerValue,
  upperValue,
  onLowerChange,
  onUpperChange,
}) => {
  const speedFormat = useAppSelector(({app}) => app.speedFormat);

  const handleSliderChange = (_: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      const [newLower, newUpper] = newValue;
      if (newLower !== lowerValue) {
        onLowerChange(newLower);
      }
      if (newUpper !== upperValue) {
        onUpperChange(newUpper);
      }
    }
  };

  const handleLowerInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    if (!isNaN(value) && value >= min && value <= upperValue) {
      onLowerChange(value);
    }
  };

  const handleUpperInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    if (!isNaN(value) && value <= max && value >= lowerValue) {
      onUpperChange(value);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={2} width="100%">
      <TextField
        type="number"
        label={`${speedFormat.toUpperCase()} Min`}
        value={lowerValue}
        onChange={handleLowerInputChange}
        inputProps={{min, max: upperValue, step: 10}}
        size="small"
      />

      <Box flex={1} minWidth={200}>
        <Slider
          value={[lowerValue, upperValue]}
          onChange={handleSliderChange}
          min={min}
          max={max}
          step={10}
          disableSwap
        />
      </Box>

      <TextField
        type="number"
        label={`${speedFormat.toUpperCase()} Max`}
        value={upperValue}
        onChange={handleUpperInputChange}
        inputProps={{min: lowerValue, max, step: 10}}
        size="small"
      />
    </Box>
  );
};

export default SpeedFilterSlider;
